import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsPhotoNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.325.325v23.35h23.35V.325H.325zm22 22H1.675V1.675h20.65v20.65z"
        fill=""
      />
      <path
        d="M6 8.675a2.675 2.675 0 100-5.35 2.675 2.675 0 000 5.35zm0-4a1.325 1.325 0 110 2.65 1.325 1.325 0 010-2.65zM3.328 18.1v2.57h17.347v-5.222L14.8 4.572l-5.071 9.514-2.174-3.915L3.328 18.1zm6.426-1.193l5.051-9.483 4.52 8.362v3.535H4.678v-.884L7.58 13l2.174 3.907z"
        fill=""
      />
    </svg>
  )
);
SvgActionsPhotoNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgActionsPhotoNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsPhotoNormalSmall;
